<template>
    <main>
        <div class="box">
            <div class="mark" @click="toggleScoreDetail"></div>
            <div class="content">
                <div class="close" @click="toggleScoreDetail"></div>
                <div class="title">积分明细</div>
                <div class="line"></div>
                <div class="list">
                    <div class="item" v-for="item in list">
                        <div class="left tit">
                            <div class="middle">{{item.title}}</div>
                        </div>
                        <div class="right stat">
                            <div class="middle">
                                <div class="num">{{item.type == 1 ? '+' : '-'}}{{item.score}}</div>
                                <div class="time">{{tool.date.formatDate('Y-m-d H:i:s',item.create_time)}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="footer">{{footer == 1 ? '上拉加载更多' : footer == 2 ? '加载中' :'没有更多内容了'}}</div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'score-detail',
        data() {
            return {
                list:[],
                footer:1,
                page:1,
            }
        },
        components:{

        },
        computed:{

        },
        methods: {
            toggleScoreDetail(){
                this.$emit('toggleScoreDetail')
            },
            getScoreList(){
                if(this.footer != 1){return false;}
                this.footer = 2;
                this.http.request({
                    api:"user/getUserScore",
                    data:{
                        page:this.page
                    },
                    success:(res)=>{
                        this.list = this.list.concat(res.list);
                        if(res.list.length < res.limit){
                            this.footer = 3;
                        }else{
                            this.footer = 1;
                            this.page = this.page + 1;
                        }
                    }
                })
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getScoreList();
        },
        destroyed() {

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{width:6.5rem;height:5.9rem;padding: .4rem  .2rem .2rem; background: #fff;position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);border-radius: .02rem;
            .close{width: .5rem;height:.5rem;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size: .3rem;cursor: pointer;transition: background .3s ease;}
            .title{font-size:.3rem;text-align: center;color:#3176c8;}
            .line{width:1.1rem;height:.06rem;margin:.05rem auto 0; background:#3176c8;}
            .list{padding:0 .2rem;height:4.8rem;overflow: hidden;overflow-y: auto;margin-top:.2rem;
                .item{ height:.8rem;border-bottom: .02rem solid #bfddf3;
                    .tit{width: 3rem;
                        .middle{width: 4rem;height:.8rem;font-size:.22rem;}
                    }
                    .stat{width: 3rem;text-align: right;
                        .middle{width: 3rem;height:.8rem;
                            .num{font-size: .22rem;color:#0176ce;}
                            .time{font-size: .18rem;color:#929292;margin-top:.05rem;}
                        }
                    }
                }
                .footer{height:.5rem;line-height: .5rem;text-align: center;font-size:.22rem;color:#999;}
            }
            .list::-webkit-scrollbar{width:.1rem;background-color: #e1e2e2;border-radius:.05rem;}
            .list::-webkit-scrollbar-thumb{background-color: #0176ce;border-radius:.05rem;}
        }
    }
</style>

